import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import apollo from '../apollo/config'
import {
	createBusiness,
	createCampaign,
	createCategory,
	createCategoryDetail,
	createContact,
	createCounselor,
	createEvent,
	createEventJoin,
	createGroup,
	createInputBox,
	createInquiry,
	createMessage,
	createMsgLog,
	createReserveday,
	createReserveuser,
	createSendEmail,
	createSendMessage,
	createSendSm,
	createTemperature,
	createTerm,
	createTrackingCode,
	createWaiting,
	deleteCampaign,
	deleteCategory,
	deleteCategoryDetail,
	deleteCounselor,
	deleteGroup,
	deleteInputBox,
	deleteMessage,
	deleteReserveday,
	deleteReserveuser,
	deleteTerm,
	deleteUser,
	fileUpload,
	login,
	multifileUpload,
	multipleUpload,
	register,
	unlockUser,
	updateAlert,
	updateBusiness,
	updateCampaign,
	updateCategory,
	updateCategoryDetail,
	updateCategoryListorder,
	updateCounselor,
	updateEvent,
	updateGroup,
	updateInputBox,
	updateMessage,
	updatePassword,
	updateReserveday,
	updateReserveuser,
	updateTerm,
	updateTrackingCode,
	updateUser,
	updateWaiting,
	updateWaitingWithCheck,
	reserveLoginAPI,
	reserveLoginCheck,
} from '../apollo/mutation'
import {
	Users,
	alerts,
	businesses,
	campaigns,
	campainCount,
	campainListCount,
	categories,
	categoryDetails,
	checkReserveusers,
	counselingCount,
	counselingRangeCount,
	counselors,
	eventJoins,
	events,
	findReserveusers,
	groups,
	groupsChat,
	inputboxes,
	me,
	messageReport,
	messages,
	msgLog,
	msgLogs,
	realTimeCount,
	realTimeWait,
	reserveday,
	reservedayMaxCount,
	reservedayMaxCount2,
	reservedayTotalReport,
	reservedays,
	reservedays_event,
	reserveuser,
	reserveusers,
	reserveusersConnection,
	reserveusersCount,
	reserveusersInputBoxTitle,
	reserveusersRangeCount,
	sendMessage_history,
	sendMessages,
	sendSms,
	showWeb,
	simpleReserveusers,
	simpleWaitings,
	temperatures,
	terms,
	trackingCodes,
	visitCount,
	visitListCount,
	visitRangeCount,
	waiting,
	waitings,
	waitingsConnection,
	waitingsCount,
	waitingsRangeCount,
	pageReserveusers,
	reserveusers_count,
	reservedayGroups,
	eventJoinsConnection,
} from '../apollo/query'
const tokenName = 'here-t'
const key = 'dsoxv94z7sbgpooiyp73efi28w55t8iw' // 카카오톡 전송 키값
const userid = 'mainframe' // 알리고 아이디
Vue.use(Vuex)
// const config = { headers: { 'x-auth-token': sessionStorage.getItem(tokenName), 'Content-Type': 'application/json' } }
export default new Vuex.Store({
	state: {
		reservedayTplCode: '',
		reservedayTplCode_event: '',
		CompanionData: 1,
		closeActive: 0,
		termId: null,
		termIdList: [],
		reservedayInputBoxDirect: [],
		searchsel_city1: {
			value: '서울특별시',
			errorMessage: '',
			hideDetail: true,
			items: [
				'서울특별시',
				'부산광역시',
				'인천광역시',
				'대구광역시',
				'대전광역시',
				'광주광역시',
				'울산광역시',
				'세종특별자치시',
				'경기도',
				'강원도',
				'충청북도',
				'충청남도',
				'전라북도',
				'전라남도',
				'경상북도',
				'경상남도',
				'제주특별자치도',
			],
			outlined: true,
			class: 'small_font bizInput',
		},
		searchsel_city2: {
			value: '강남구',
			disabled: true,
			errorMessage: '',
			hideDetail: true,
			items: [],
			outlined: true,
			class: 'small_font bizInput',
		},
		searchsel_city3: {
			value: '개포제1동',
			disabled: true,
			errorMessage: '',
			disable: false,
			hideDetail: true,
			items: [],
			outlined: true,
			class: 'small_font bizInput',
		},
		rangeStatus: [], // rangeCard 데이터 리스트 수정
		customerManagementTabs: [], //customerManagement Tabs 데이터
		dashBoardList: [], // nav 리스트
		backSocket: process.env.VUE_APP_BACKEND_SOCKET,
		backServer: process.env.VUE_APP_BACKEND_URL,
		frontServer_upload: process.env.VUE_APP_BACKEND_ADMIN_URL,
		sampleWaitingData: {},
		fileUploadProgress: 0,
		PointColor1: '#3E7CCC',
		PointColor2: '#3E7CCC',
		PointColor3: '#F2B705',
		PointColor4: '#8C6B08',
		PointColor5: '#ffffff',
		PointColor6: '#F2B705',
		PointColor7: '#3E7CCC',
		PointColor8: '#ffffff',
		PointColor9: '#202840',
		PointColor10: '#009EA1',
		PointColor11: '#878787',
		userAPIs: {},
		logoUrl: '',
		groupData: {},
		chatStatus: false,
		bellStatus: false,
		bellNum: { alert: 0, chat: 0, package: 0 },
		drawer: false,
		userimgfile: [],
		apikey: key,
		userid: userid,
		host: process.env.VUE_APP_BACKEND_URL,
		meData: { role: { name: '' }, group: { groupcode: '' }, visit: 0, day: 0, event: 0 },
		leftNavDrawer: true,
		loading: false, // 로딩바
		ResetConfMapItems: [],
		datatable: [],
		selectedGroup: '',
		selectedInputBox: '',
		targetId: '', // update & delete 시 사용
		inputUserData: {},
		uploadFileData: {}, // upload file data
		uploadFileDataDirect: {}, // upload file data
		uploadFileQrlogo: {}, // upload file data
		uploadCompanionImg: {},
		filesData: [], // multiple upload file data
		categoryItem: {},
		detailItem: {},
		selChips: '',
		boardList: [],
		reservedayInputBox: [],
		trackingCodeId: '',
		trackingCodeCode: '',
		counserlorLoginData: {},
		// viewport 설문 데이터
		picker: {
			date: '',
			errorMessage: '',
		}, // viewport 날짜 선택 옵션
		maxcount: '', // 각 시간마다 예약 최대 인원
		nodaySetting: [], // noday setting
		timeRange: '', // 예약 운영 시간 범위
		startDate: '', // 시작 날짜
		endDate: '', // 종료 날짜
		selectedValues: [],
		selectedTime: '', // viewport 선택한 시간
		selectedTimeDetail: '', // viewport 선택한 시간 detail
		check1: {
			color: 'primary',
			class: 'allAgree',
			value: false,
			label: '전체 동의하기',
			onicon: 'mdi-check-circle',
			officon: 'mdi-check-circle-outline',
		},
		check2: {
			color: 'primary',
			class: 'smallLabel',
			value: false,
			label: '이용 약관 동의 (필수)',
			onicon: 'mdi-check',
			officon: 'mdi-check',
		},
		check3: {
			color: 'primary',
			class: 'smallLabel',
			value: false,
			label: '개인정보수집•이용동의 (필수)',
			onicon: 'mdi-check',
			officon: 'mdi-check',
		},
		check4: {
			color: 'primary',
			class: 'smallLabel',
			value: false,
			label: '고유식별 수집동의 (필수)',
			onicon: 'mdi-check',
			officon: 'mdi-check',
		}, // viewport 약관 옵션
		check5: {
			color: 'primary',
			class: 'smallLabel',
			value: false,
			label: '마케팅 활용 동의 (선택)',
			onicon: 'mdi-check',
			officon: 'mdi-check',
		}, // viewport 약관 옵션
		check6: {
			color: 'primary',
			class: 'smallLabel',
			value: false,
			label: '마케팅 활용 동의 (선택)',
			onicon: 'mdi-check',
			officon: 'mdi-check',
		}, // viewport 약관 옵션
		groupname: '', // reserve_day & reserve_visit 에 필요한 groupname
		reserveuserId: '',
		reserveUpdateDate: '', // reserve_day 예약일시
		reservedDate: '', // reserve_day 방문일시
		reservedTime: '', // reserve_day 방문시간
		timeDataCopy: [], // reserve_day 시간테이블
		reservedayData: '',
		reserveusersData: {
			fileUpload: [],
		},
		reserveUserData: {
			reserveUpdateDate: '',
			name: '',
			reservedDate: '',
		},
		messageData: {},
		usersImg: [],
		reservedayInputBoxSample: [], //sample drag data
		nowRadioValue: [],
	},
	mutations: {
		reservedayInputBoxDirect(state, payload) {
			state.reservedayInputBoxDirect = payload
		},
		fileUploadProgress(state, payload) {
			state.fileUploadProgress = payload
		},
		reservedayData(state, payload) {
			state.reservedayData = payload
		},
		messageData(state, payload) {
			state.messageData = payload
		},
		maxcount(state, payload) {
			state.maxcount = payload
		},
		nodaySetting(state, payload) {
			state.nodaySetting = payload
		},
		timeRange(state, payload) {
			state.timeRange = payload
		},
		startDate(state, payload) {
			state.startDate = payload
		},
		endDate(state, payload) {
			state.endDate = payload
		},
		reserveuserId(state, payload) {
			state.reserveuserId = payload
		},
		loading(state, payload) {
			state.loading = payload
		},
		meData(state, payload) {
			state.meData = payload
		},
		selectedGroup(state, payload) {
			state.selectedGroup = payload
		},
		selectedInputBox(state, payload) {
			state.selectedInputBox = payload
		},
		targetId(state, payload) {
			state.targetId = payload
		},
		uploadFileData(state, payload) {
			state.uploadFileData = payload
		},
		uploadFileDataDirect(state, payload) {
			state.uploadFileDataDirect = payload
		},
		uploadFileQrlogo(state, payload) {
			state.uploadFileQrlogo = payload
		},
		uploadCompanionImg(state, payload) {
			state.uploadCompanionImg = payload
		},
		filesData(state, payload) {
			state.filesData = payload
		},
		categoryItem(state, payload) {
			state.categoryItem = payload
		},
		detailItem(state, payload) {
			state.detailItem = payload
		},
		boardList(state, payload) {
			state.boardList = payload
		},
		reservedayInputBox(state, payload) {
			state.reservedayInputBox = payload
		},
		reservedayInputBoxSample(state, payload) {
			state.reservedayInputBoxSample = payload
		},
		trackingCodeId(state, payload) {
			state.trackingCodeId = payload
		},
		trackingCodeCode(state, payload) {
			state.trackingCodeCode = payload
		},
		counserlorLoginData(state, payload) {
			localStorage.setItem('counserlor', payload.name + ',' + payload.counselorid)

			state.counserlorLoginData.name = payload.name + '|' + payload.counselorid
		},
		picker(state, payload) {
			state.picker = payload
		},
		selectedTime(state, payload) {
			state.selectedTime = payload
		},
		selectedTimeDetail(state, payload) {
			state.selectedTimeDetail = payload
		},
		check1(state, payload) {
			state.check1 = payload
		},
		check2(state, payload) {
			state.check2 = payload
		},
		check3(state, payload) {
			state.check3 = payload
		},
		check4(state, payload) {
			state.check4 = payload
		},
		check5(state, payload) {
			state.check5 = payload
		},
		check6(state, payload) {
			state.check6 = payload
		},
		selectedValues(state, payload) {
			state.selectedValues = payload
		},
		usersImg(state, payload) {
			state.usersImg = payload
		},
	},
	actions: {
		// eslint-disable-next-line no-empty-pattern
		checkreserve({}, input) {
			return new Promise((resolve, reject) => {
				let config = {
					headers: {
						Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
					},
				}
				axios
					.get(process.env.VUE_APP_BACKEND_URL + '/checkreserve?tplCode=' + input.tplCode + '&code=' + input.code, config)
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		eventJoinCount({}, input) {
			return new Promise((resolve, reject) => {
				let config = { headers: {} }
				axios
					.get(process.env.VUE_APP_BACKEND_URL + '/event-joins/count?code=' + input.code, config)
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createSendMessage({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createSendMessage, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		sendMessage({ dispatch }, input) {
			return new Promise((resolve, reject) => {
				dispatch('getToken').then(res => {
					var formData = new FormData()
					formData.append('token', res.data.token)
					for (var key in input) {
						formData.append(key, input[key])
					}
					let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
					axios
						.post('https://kakaoapi.aligo.in/akv10/alimtalk/send/', formData, config)
						.then(data => {
							resolve(data)
						})
						.catch(err => {
							reject(err)
						})
				})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		getMessages({}, input) {
			input.apikey = key
			input.userid = userid
			return new Promise((resolve, reject) => {
				let config = { headers: {} }
				axios
					.post('https://apis.aligo.in/send/', input, config)
					.then(data => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// ------------------------------------ Account Controller ------------------------------------
		// me data 조회
		me({ commit }) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: me,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(({ data }) => {
						resolve(data)
						commit('meData', data.me)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		login({ commit }, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: login, variables: input })
					.then(({ data }) => {
						sessionStorage.setItem(tokenName, data.login.jwt)
						commit('meData', data.login.user)
						resolve(data.login.user)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		pageReserveusers({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: pageReserveusers,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// 단일 파일 업로드
		// eslint-disable-next-line no-empty-pattern
		superAdminFileUpload({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: fileUpload, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		upload({}, input) {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('files', input.file)
				let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
				axios
					.post(process.env.VUE_APP_BACKEND_URL + '/upload', formData, config)
					.then(data => {
						var formData2 = new FormData()
						formData2.append('file', input.file)
						formData2.append('name', data.data[0].hash + data.data[0].ext)
						let config = { headers: { 'Content-Type': 'multipart/form-data; charset: utf-8', 'Content-Disposition': 'utf-8' } }
						axios.post(process.env.VUE_APP_CUSTOMER_URL + '/upload', formData2, config)
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		fileUpload({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: fileUpload, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// 복수 파일 업로드
		// eslint-disable-next-line no-empty-pattern
		multipleUpload({}, input) {
			return new Promise((resolve, reject) => {
				// context: {
				// 	headers: {
				// 		Authorization: 'Bearer ' + sessionStorage.getItem('hlw-t'),
				// 			},
				// },
				apollo.clients['defaultClient']
					.mutate({ mutation: multipleUpload, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		multifileUpload({ commit }, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: multifileUpload,
						variables: input,
						context: {
							fetchOptions: {
								onUploadProgress: progress => {
									commit('fileUploadProgress', (progress.loaded / progress.total) * 100)
								},
							},
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateCounselor({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateCounselor, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createCounselor({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createCounselor, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteCounselor({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteCounselor, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		counselors({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: counselors,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		searchGroups({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: groups,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		groups({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: groups,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		groupsChat({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: groupsChat,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		qrgroups({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: groups,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createGroup({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createGroup, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateGroup({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateGroup, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteGroup({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteGroup, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		categories({}) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: categories,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createCategory({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createCategory, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateCategory({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateCategory, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateCategoryListorder({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateCategoryListorder, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteCategory({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteCategory, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		categoryDetails({}) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: categoryDetails,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createCategoryDetail({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createCategoryDetail, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateCategoryDetail({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateCategoryDetail, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteCategoryDetail({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteCategoryDetail, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		terms({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: terms,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createTerm({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createTerm, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateTerm({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateTerm, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteTerm({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteTerm, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveday({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveday,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedays_event({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedays_event,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedays({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedays,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveusers_count({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveusers_count,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createReserveday({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: createReserveday,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateReserveday({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: updateReserveday,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteReserveday({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: deleteReserveday,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		messages({}, input) {
			return new Promise((resolve, reject) => {
				// context: {
				// 	headers: {
				// 		Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
				// 			},
				// },
				apollo.clients['defaultClient']
					.query({
						query: messages,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createMessage({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createMessage, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		updateMessage({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateMessage, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteMessage({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteMessage, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		inputboxes({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: inputboxes,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createInputBox({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createInputBox, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateInputBox({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateInputBox, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteInputBox({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteInputBox, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		checkReserveusers({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: checkReserveusers,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		eventJoinsConnection({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: eventJoinsConnection,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		findReserveusers({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: findReserveusers,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		simpleReserveusers({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: simpleReserveusers,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createEventJoin({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: createEventJoin,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		sendMessage_history({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: sendMessage_history,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveusersConnection({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveusersConnection,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		waitingsConnection({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: waitingsConnection,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		eventJoins({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: eventJoins,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveusers({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveusers,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createReserveuser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createReserveuser, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateReserveuser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateReserveuser, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteReserveuser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteReserveuser, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		Users({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: Users,
						// context: {
						// 	headers: {
						// 		Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
						// 	},
						// },
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		register({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: register, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteUser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: deleteUser,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateUser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: updateUser,
						variables: input,
						// context: {
						// 	headers: {
						// 		Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
						// 	},
						// },
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		campaigns({}) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: campaigns,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		trackingCodes({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: trackingCodes,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createCampaign({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createCampaign, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		deleteCampaign({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: deleteCampaign, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateCampaign({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateCampaign, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createTrackingCode({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createTrackingCode, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateTrackingCode({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateTrackingCode, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		waiting({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: waiting,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		waitings({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: waitings,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		simpleWaitings({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: simpleWaitings,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		msgLog({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: msgLog,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		msgLogs({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: msgLogs,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createWaiting({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createWaiting, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateWaiting({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateWaiting, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveLoginAPI({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: reserveLoginAPI, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveLoginCheck({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: reserveLoginCheck, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateWaitingWithCheck({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateWaitingWithCheck, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createMsgLog({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createMsgLog, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedayMaxCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedayMaxCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveusersInputBoxTitle({}, input) {
			return new Promise((resolve, reject) => {
				apollo.defaultClient
					.query({
						query: reserveusersInputBoxTitle,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveusersCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveusersCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		reserveusersRangeCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveusersRangeCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		waitingsCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: waitingsCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		waitingsRangeCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: waitingsRangeCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		temperatures({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: temperatures,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createTemperature({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createTemperature, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		campainCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: campainCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		campainListCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: campainListCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		realTimeCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: realTimeCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		visitListCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: visitListCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		visitRangeCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: visitRangeCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		visitCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: visitCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		counselingCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: counselingCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		counselingRangeCount({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: counselingRangeCount,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedayMaxCount2({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedayMaxCount2,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		messageReport({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: messageReport,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		createSendEmail({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createSendEmail, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updatePassword({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updatePassword, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		unlockUser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: unlockUser, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedayGroups({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedayGroups,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		alerts({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: alerts,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateAlert({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: updateAlert, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createContact({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({ mutation: createContact, variables: input })
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		realTimeWait({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: realTimeWait,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		businesses({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: businesses,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createBusiness({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: createBusiness,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateBusiness({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: updateBusiness,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// eslint-disable-next-line no-empty-pattern
		showWeb({}, input) {
			return new Promise((resolve, reject) => {
				apollo.defaultClient
					.query({
						query: showWeb,
						variables: input,
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createSendSm({}, input) {
			return new Promise((resolve, reject) => {
				apollo.defaultClient
					.mutate({
						mutation: createSendSm,
						variables: input,
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createInquiry({}, input) {
			return new Promise((resolve, reject) => {
				apollo.defaultClient
					.mutate({
						mutation: createInquiry,
						variables: input,
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		events({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: events,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reservedayTotalReport({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reservedayTotalReport,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		sendMessages({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: sendMessages,
						variables: input,
						// context: {
						// 	headers: {
						// 		Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
						// 	},
						// },
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		createEvent({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: createEvent,
						variables: input,
						context: {
							headers: {
								Authorization: 'Bearer ' + sessionStorage.getItem(tokenName),
							},
						},
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		updateEvent({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.mutate({
						mutation: updateEvent,
						variables: input,
					})
					.then(({ data }) => {
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		reserveuser({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: reserveuser,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
		// eslint-disable-next-line no-empty-pattern
		sendSms({}, input) {
			return new Promise((resolve, reject) => {
				apollo.clients['defaultClient']
					.query({
						query: sendSms,
						variables: input,
					})
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
		},
	},

	modules: {},
})
